
import React, {useContext} from 'react';
//import 'typeface-roboto'; // Unclear if this is needed, seems to only be used for Typography.  Was also installed by npm.



import StatusBox from '../src/Components/Global/StatusBar';
import MenuBar from '../src/Components/Global/Main_Menu';
import NewsItemsMain from '../src/Components/Global/NewsItems';

import { ContextProvider, Context_Navigation, Context_Loyalty_Program, Context_Compliance_Scores } from '../src/Data/ContextProvider';

import MyFooter from '../src/Components/Global/Footer';

//import MyApp from './_app'



export default function Home() {
  const [Navigation_GVars, Update_Navigation_GVars] = useContext(Context_Navigation);
  return (

    <div>
      
      <head>
        {/* Global site tag (gtag.js) - Google Analytics */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-T2JKLXV9T9"></script>
        <script>{injectGA()}

      </script>
      </head>

      <meta name="viewport" content="width=device-width" >
        
      </meta>
      <ContextProvider>
        <Index_Entry_Page/>

      </ContextProvider>

      <div className='vertical_Bar_CSS'></div>

      </div>

  );
}

const injectGA = () => {
  if (typeof window == 'undefined') {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  gtag('js', new Date());

  gtag('config', 'G-T2JKLXV9T9');
};

function Index_Entry_Page() {
  const [Navigation_GVars, Update_Navigation_GVars] = useContext(Context_Navigation);
  const [Loyalty_Program_GVars, Update_Loyalty_Program_GVars] = useContext(Context_Loyalty_Program);
  const [StatusBox_Data_GVars, Update_StatusBox_Data_GVars] = useContext(Context_Compliance_Scores);


  return (
    <div>

      <div className='about_Header'> <h4> >> Home </h4></div>


      {Navigation_GVars.welcomeText ?
        <div>
          {Navigation_GVars.statusBox ? <> <StatusBox /> </> : <></>}
          <MenuBar />
          <MyFooter />
          <div className='page_Tracker'> >> Home  </div>
          {Navigation_GVars.index_ShowIndustries ? <> <div className="industries_Header_On" onClick={show_Industries} > Industry Segments: </div > <div className="industries_Header_Bubble"> </div>  </> : <div className="industries_Header_Off" onClick={show_Industries} >Industry Segments: </div >}

          {Navigation_GVars.index_ShowTopics ? <> <div className="topics_Header_On" onClick={show_Topics} > Topics: </div > <div className="topics_Header_Bubble"> </div>  </> : <div className="topics_Header_Off" onClick={show_Topics} >Topics: </div >}

          {Navigation_GVars.index_ShowLegalAreas ? <> <div className="legalAreas_Header_On" onClick={show_LegalAreas} > Legal Areas: </div > <div className="legalAreas_Header_Bubble"> </div>  </> : <div className="legalAreas_Header_Off" onClick={show_LegalAreas} >Legal Areas: </div >}

          {Navigation_GVars.index_ShowHow ? <> <div className="howtoUse_Header_On" onClick={show_How} > How to get started: </div > <div className="howtoUse_Header_Bubble"> </div>  </> : <div className="howtoUse_Header_Off" onClick={show_How} > How to get started: </div >}

          {Navigation_GVars.index_ShowNews ? <> <div className="news_Header_On" onClick={show_News} > News and Updates: </div > <div className="news_Header_Bubble"> </div>  </> : <div className="news_Header_Off" onClick={show_News} > News and Updates: </div >}

          {Navigation_GVars.index_ShowGoals ? <> <div className="goals_Header_On" onClick={show_Goals} > About this website: </div > <div className="goals_Header_Bubble"> </div>  </> : <div className="goals_Header_Off" onClick={show_Goals} >About this website: </div >}

          <div className="news_Header" onClick={show_News}>  </div >
          <div className="mainBar">  </div >
          <div className="main_Box">  </div >
        </div > : <></>}

      {Navigation_GVars.index_ShowIndustries ?
        <div className='main_Box'>
          <div className='welcomeTextBlue'> <h4> Industry Segments Covered on this Website:</h4> </div>
          <br></br>
          <div className='welcomeTextBlue'> Omnicommerce and E-Banking:</div>
          <ul>
            <li> Electronic Commerce (E-Commerce)</li>
            <br></br>
            <li>Payments, including Payment Processor business models, Gateways, and other intermediaries in the Credit Card Network payments stream</li>
            <br></br>
            <li> Loyalty Programs, Rewards Programs, and other similar customer retention programs </li>
            <br></br>
            <li>Prepaid Accounts and other consumer and business accounts held via mobile apps or in the cloud</li>
            <br></br>
            <li>Gift Cards and Gift Certificates</li>
            <br></br>
            <li>Open loop and closed loop credit programs</li>
            <br></br>
            <li>Lending business models for both consumers (B2C) and businesses (B2B)</li>
            <br></br>
            <li>Installment payment programs</li>
            <br></br>
            <li>Credit Cards, including direct and white label offerings</li>
            <br></br>
            <li>B2B and B2C E-Commerce networks, including integrated payments, loyalty, giftcards, and other omnicommerce services</li>
            <br></br>
            <li>Credit Card Networks (including rules and regulations, Chargebacks, issuance, and settlmement)</li>
            <br></br>
            <li> Automated Clearing House (ACH) Payments</li>
            <br></br>
            <li>Digitial Coupons and Digital Offers</li>
            <br></br>
            <li>Point of Sale</li>
            <br></br>
            <li>Enterprise Resource Planning (ERP) systems</li>
            <br></br>
            <li>Electronic Banking (E-Banking)</li>
            <br></br>
            <li>Savings Accounts and Checking Accounts</li>
            <br></br>
            <li>FDIC insured banking models</li>
            <br></br>
            <li>Consumer and Business Lending</li>
            <br></br>
            <li>Data Analytics and Data Monetization</li>
            <br></br>
            <li>Application Programming Interface (API) data flows and information exchange</li>
            <br></br>
            <li>Data As A Service (DAAS) and other data licensing arrangements</li>
          </ul>
          <br></br>
          <div className='welcomeTextBlue'> Blockchain and Cryptocurrencies:</div>
          <ul>
            <li> Blockchain networks, including applications in cryptocurrency payments, E-Commerce, record-keeping, compliance, logistics, and immutability of information</li>
            <br></br>
            <li>Cryptocurrencies</li>
            <br></br>
            <li>Stablecoins</li>
            <br></br>
            <li>Cryptographic tokens, including tokenization of Loyalty Programs, securitization of debt, and other E-Commerce applications</li>
            <br></br>
            <li>Smart Contracts</li>
            <br></br>
            <li>Payment business models based on Bitcoin, Ethereum and other cryptocurrencies</li>
          </ul>
          <br></br>
          <div className='welcomeTextBlue'> Advanced Technologies: </div>
          <ul>
            <li> Artificial Intelligence (AI), including Neural Network architecture and training, and applications in E-Commerce, Data Monetization, SAAS, and Autonomous Driving</li>
            <br></br>
            <li>Semiconductors, including design, CAD, EDA, simulation, manufacturing, packaging, inspection, tesign and metrology </li>
            <br></br>
            <li>Advanced computing, including microprocessors, mobile processors, AI customized processors, ASICs, and computing systems</li>
            <br></br>
            <li>Quantum Computing</li>
            <br></br>
            <li>Software</li>
            <br></br>
            <li>SAAS, including platform development, deployment, operation, commercialization and phase-out</li>
            <br></br>
            <li>Hardware</li>
            <br></br>
            <li>Memory, inclyding NAND Flash Memory, NOR Flash Memory, DRAM, cash memory systems, and 3D memory architectures </li>
            <br></br>
            <li>Communication Networks, including 5G, WiFi, Cellular, Satellite networks and gateways, other wireless protocols, and wireline</li>
            <br></br>
            <li>Cloud Architecture</li>
            <br></br>
            <li>Mobile Apps and Cloud integration</li>
            <br></br>
            <li>Open Source</li>
            <br></br>
            <li>Data encryption and data compression</li>
            <br></br>
            <li>Client, edge and cloud security</li>
            <br></br>
            <li>Clean energy, including electric vehicles, electric charging, and battery technologies</li>
            <br></br>
            <li>Autonomous vehicles</li>
            <br></br>
            <li>Augmented Reality (AR) and Virtual Reality (VR), including consumer applications</li>
            <br></br>
            <li>Medical technology, including stationary equipment, mobile devices, and wearables</li>
            <br></br>
            <li>DNA and genetic data analytics</li>
            <br></br>
            <li>Laser technologies and applications in communications, LIDAR and medical applications</li>
            <br></br>
            <li>Nanotechnology and applications</li>
          </ul>

        </div > : <></>}
      
      {Navigation_GVars.index_ShowTopics ?
        <div className='main_Box'>
          <div className='welcomeTextBlue'> <h4> Topics that will be addressed on this website:</h4> </div>
          <ul>
            <li>Legal and regulatory frameworks (e.g,. US Federal and State laws, Regulatory Agencies, laws and regulations from the EU, UK, Canada, and some select jurisdictions from LATAM and APAC) </li>
            <br></br>
            <li>Compliance frameworks and effective compliance programs</li>
            <br></br>
            <li>Operational best practices across all company growth stages, from startups, to small and medium businesses (SMBs), to public companies (e.g., BKMs for maximizing customer retention and minimizing revenue churn, credit card collections, B2B and B2C scaling, etc.)</li>
            <br></br>
            <li>Legal agreements optimized for fast customer adoption and business scaling (e.g., evolution of liabilty framework across company growth stages, practical tradeoffs between customer-friendly legal terms and liability mitigation, effective allocation of liability across the commercial chain, etc.)</li>
            <br></br>
            <li>Funding strategies (e.g., angel funding, venture capital (VC), private equity (PE), strategic investors, lending, commercial transactions optimized for capital accrual, warrants, croudfunding, etc.)</li>
            <br></br>
            <li>Optimization of exists (e.g., equity and </li>
          </ul>
        </div > : <></>}

      
      {Navigation_GVars.index_ShowLegalAreas ?
        <div className='main_Box'>
          <div className='welcomeTextBlue'> <h4> Legal and regulatory areas that will be addressed on this website: </h4> </div>
          <br></br>
          <div className='welcomeTextBlue'> Electronic Commerce (E-Commerce) Laws and Regulations: </div>
          <ul>
            <li> The Dodd-Frank Act and subsequent amendments</li>
            <br></br>
            <li>The Electronic Fund Transfer Act (EFTA) – Regulation E</li>
            <br></br>
            <li>Truth in Lending Act (TILA) – Regulation Z</li>
            <br></br>
            <li>Consumer Leasing Act – Regulation M</li>
            <br></br>
            <li>Expedited Funds Availability Act (EFA Act) – Regulation CC</li>
            <br></br>
            <li>The unfair, deceptive, or abusive acts or practices framework (UDAAP) overseen by the CFPB</li>
            <br></br>
            <li>The unfair or deceptive acts or practices framework (UDAP) overseen by the FTC</li>
            <br></br>
            <li>Prepaid Accounts Rule</li>
            <br></br>
            <li>Controlling the Assault of Non-Solicited Pornography and Marketing (CAN-SPAM)</li>
            <br></br>
            <li>Telephone Consumer Protection Act (TCPA)</li>
            <br></br>
            <li>E-Sign Act</li>
            <br></br>
            <li>Fair Credit Reporting Act (FCRA) – Regulation V</li>
            <br></br>
            <li>Right to Financial Privacy Act (RFPA)</li>
            <br></br>
            <li>Children’s Online Privacy Protection Act (COPPA)</li>
            <br></br>
            <li>Payment Card Industry Standards (The Payment Card Industry Data Security Standard for Merchants and Processors (PCI DSS), The Payment Application Data Security Standard (PA-DSS), The PCI Point-to-Point Encryption (P2PE) Standard, The PCI PIN Security Standard, The Pin Transaction Security (PTS) Hardware Security Module (HSM) Standard, The PCI PIN Security Requirements Standard, The PIN Transaction Security (PTS) Point of Interaction (POI) Standard, The Card Production and Provisioning (CPP) Standard, The PCI Card Production and Provisioning Physical Security (CPPPS) Requirements Standard, The PCI Three-Domain Secure (3-D Secure, or 3DS) Standard, Additional Security Requirements and Assessment Procedures for Token Service Providers (EMV Payment Tokens)) </li>
            <br></br>
            <li>Payment Card Networks Rules established by Visa, MasterCard and other Credit Card Network Operators </li>
            <br></br>
            <li>National Automated Clearing House Association (NACHA) Operating Rules in the U.S.</li>
            <br></br>
            <li>Single Euro Payments Area (SEPA) Regulation in Europe, implemented by Regulation (EU) No 260/2012 of the European Parliament dated March 14, 2012 and European Payments Council Rulebooks</li>
            <br></br>
            <li>Uniform Electronic Transaction Act (UETA – States)</li>
            <br></br>
            <li>Data privacy and security laws</li>
          </ul>


          <br></br>
          <div className='welcomeTextBlue'> Electronic Banking (E-Banking) Laws Regulations: </div>
          <ul>
            <li> Bank Secrecy Act (BSA) and USA PATRIOT Act
</li>
            <br></br>
            <li>The Dodd-Frank Act and subsequent amendments</li>
            <br></br>
            <li>Truth in Savings (TISA) – Regulation DD</li>
            <br></br>
            <li>Consumer Leasing Act – Regulation M</li>
            <br></br>
            <li>Secure and Fair Enforcement for Mortgage Licensing Act</li>
            <br></br>
            <li>Military Lending Act (MLA)</li>
            <br></br>
            <li>Community Reinvestment Act (Sec. 345.41(a) of FDIC regulations) </li>
            <br></br>
            <li>Interstate Banking and Branching (Regulation H - Part 369 of FDIC Rules)</li>
            <br></br>
            <li>Retail Investment Sales (Gramm- Leach-Bliley Act (GLBA), Inter-Agency Rules)</li>
            <br></br>
            <li>Broker/Dealer Rules and Exemptions (Reg. R)</li>
            <br></br>
            <li>Retail Insurance Sales (FDIC Part 343, Inter-Agency Policy Statement)</li>
            <br></br>
            <li>Advertisement of Membership (Section 328 of FDIC Rules)</li>
            <br></br>
            <li>Privacy of Consumer Financial Information (GLBA))</li>
            <br></br>
            <li>E-Sign Act</li>
          </ul>

        </div > : <></>}



      {Navigation_GVars.index_ShowHow ?
        <div className='main_Box'>
          <div className='welcomeTextBlue'> <h4>There are two ways to start exploring laws, regulations, compliance, and operational guidelines as they relate to your business. </h4>
          <br></br> 
          <div> From the top left menu, you can select one of the following: </div> </div>
          <ul>
            <li>The <a  href="./business_model">Check your Business Model</a> tab will help you check your business model, and the analysis engine will walk you through a set of relevant topics to evaluate your business and provide some insights and suggestions.</li>
          <br></br>
            <li>The <a href="./explore_laws">Explore Laws and Regulations</a> tab will allow you to select specific legal or regulatory topics from the menu and learn directly about relevant laws and regulations.</li>

              </ul>
        </div > : <></>}
      
      {Navigation_GVars.index_ShowGoals ?
        <div className='main_Box'>
          <div className='welcomeTextBlue'> <h4> Goals for this website:</h4> </div>
          <ul>
            <li>Help you understand what laws and regulations may apply to your business</li>
            <br></br>
            <li>Help you learn about those laws and regulations</li>
            <br></br>
            <li>Share with you practical operational and business trends that I see in the industry</li>
            <br></br>
            <li>Leverage my experience working both inside and outside companies to give you real-world and practical solutions to fund and scale your business</li>
          </ul>
          <br></br>
          <h4> I hope you find this website useful!  If you do, send me an email at marius@svskyline.com and say "Hi!"</h4>
        </div > : <></>}
      

      {Navigation_GVars.index_ShowNews ?
        <div className='main_Box'>
          <NewsItemsMain/>
        </div > : <></>}
      </div>

  );

  

  function show_Industries() {
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowIndustries: true }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowGoals: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowHow: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowNews: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowTopics: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowLegalAreas: false }))
  }

  function show_Topics() {
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowTopics: true }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowGoals: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowHow: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowNews: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowLegalAreas: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowIndustries: false }))
  }

  function show_LegalAreas() {
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowLegalAreas: true }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowTopics: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowGoals: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowHow: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowNews: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowIndustries: false }))
  }

  

  function show_How() {
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowHow: true }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowGoals: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowNews: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowTopics: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowLegalAreas: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowIndustries: false }))
  }

  function show_News() {
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowNews: true }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowGoals: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowHow: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowTopics: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowLegalAreas: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowIndustries: false }))
  }


  function show_Goals() {
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowGoals: true }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowHow: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowNews: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowTopics: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowLegalAreas: false }))
    Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, index_ShowIndustries: false }))
  }


  

}







